module.exports = __webpack_public_path__ + "static/media/teaching.ed552dc5.png";